import { onCleanup } from "solid-js";
import { DotLottie } from "@lottiefiles/dotlottie-web";

declare namespace Lottie {
  type Props = {
    src: string;
    class?: string;
  };
}

function Lottie({ src, class: className }: D<Lottie.Props>) {
  return (
    <canvas
      ref={(canvas) => {
        const lottie = new DotLottie({
          autoplay: true,
          loop: false,
          canvas,
          src,
        });

        onCleanup(() => {
          lottie.destroy();
        });
      }}
      class={className}
    />
  );
}

export default Lottie;
